import { defineComponent as _defineComponent } from 'vue'
import InputSearch from "@/components/ui/input/InputSearch.vue";
  import { ref, watch } from "vue";
  import router from "@/router";
  import store from "@/store";
  import { UserInterface } from "@/types/UserInterface";
  import { getFirstLastName } from "@/helpers/user";
  import { debounce } from "@/helpers/debounce";
  import { UserRoles } from "@/enums/UserRoles";

  interface CompanyData {
    detailsId: string;
    companyName: string;
    adminName: string;
    adminEmail: string;
    status: string;
    users: UserInterface[];
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminUsers',
  setup(__props, { expose: __expose }) {
  __expose();

  const users = ref<UserInterface[]>([]);
  const companies = ref<CompanyData[]>([]);
  const searchQuery = ref("");
  const loading = ref(true);

  const getUsers = () => {
    store
      .dispatch("user/getUsers", {
        query: searchQuery.value,
        role: UserRoles.LANDOWNER,
      })
      .then((res) => {
        users.value = res.data;
        groupUsersByCompany();
      })
      .finally(() => (loading.value = false));
  };

  const groupUsersByCompany = () => {
    const companyMap = new Map<string, CompanyData>();

    users.value.forEach((user) => {
      const details = user.detailsId;

      if (!details || typeof details === "string") return;

      if (!details._id) return;

      const detailsId = details._id;
      const companyName =
        "companyName" in details ? details.companyName : "Unknown Company";

      if (!companyMap.has(detailsId)) {
        companyMap.set(detailsId, {
          detailsId,
          companyName,
          adminName: getFirstLastName(user),
          adminEmail: user.email,
          status: user.verifiedEmail ? "Active" : "Pending",
          users: [],
        });
      }

      const company = companyMap.get(detailsId);

      if (company) {
        company.users.push(user);
      }
    });

    companies.value = Array.from(companyMap.values());
  };

  const debounceSearch = debounce(getUsers);

  watch(
    () => router.currentRoute.value,
    () => {
      getUsers();
    },
    {
      immediate: true,
    }
  );

  watch(
    () => searchQuery.value,
    () => {
      debounceSearch();
    }
  );
  const toCompany = (detailsId: string) => {
    // Find the first user with this detailsId to use as company representative
    const companyUser = users.value.find((u) => {
      const details = u.detailsId;

      return (
        details && typeof details !== "string" && details._id === detailsId
      );
    });

    if (companyUser) {
      router.push({
        name: "AdminUser",
        params: { userId: companyUser._id },
      });
    }
  };

  const toCreateUser = () => {
    router.push({
      name: "AdminUsersCreate",
    });
  };

const __returned__ = { users, companies, searchQuery, loading, getUsers, groupUsersByCompany, debounceSearch, toCompany, toCreateUser, InputSearch, ref, watch, get router() { return router }, get store() { return store }, get UserInterface() { return UserInterface }, get getFirstLastName() { return getFirstLastName }, get debounce() { return debounce }, get UserRoles() { return UserRoles } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})